<template>
    <OrderSourceMainInformationCard v-if="orderSource" :order-source="orderSource" @update:orderSource="orderSource = $event" />
    <OrderSourceOrdersTableCard
        v-if="orderSource"
        :orderSource="orderSource"
    />
</template>
<script>
import OrderSourceMainInformationCard from "./cards/MainInformationCard.vue";
import OrderSourceOrdersTableCard from "./cards/OrdersTableCard.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: 'OrderSourceEditPage',
    components: {
        OrderSourceMainInformationCard, OrderSourceOrdersTableCard
    },
    data() {
        return {
            orderSource: null
        }
    },
    mounted() {
        this.orderSource = this.$store.getters['route/crmOrderSource']
    }
}
</script>